import { render, staticRenderFns } from "./keywordCollect.vue?vue&type=template&id=68fdc16e&scoped=true"
import script from "./keywordCollect.vue?vue&type=script&lang=js"
export * from "./keywordCollect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fdc16e",
  null
  
)

export default component.exports